import { AmountValue } from 'common/interfaces';
import { Currency } from 'enums';

export enum Horizon {
  RENT_START = 'RENT_START',
  ALL_TIME = 'ALL_TIME',
  PERIOD = 'PERIOD',
  INITIAL = '',
}

export interface Reserve {
  id?: string;
  title: string;
  value: AmountValue;
  horizon: Horizon;
  until?: string;
  bucket: string;
  cancellationLimitActive: boolean;
  cancellationLimit: number | string;
  currentLimit: number | string;
  newDeposits: boolean;
}

export interface ReservesOptions {
  horizon: string[];
  minLimit: number;
  maxLimit: number;
  maxDate: string;
  bucket: string[];
}

export interface ReservesData {
  reserves: Reserve[];
  addingEnabled: boolean;
  options: ReservesOptions;
}

export const getInitialValues = (currency: Currency)  => ({
  title: '',
  value: { value: 0, currency: currency },
  horizon: Horizon.INITIAL,
  until: '',
  bucket: '',
  cancellationLimitActive: false,
  cancellationLimit: '',
  currentLimit: '',
  newDeposits: true,
});
